import { render, staticRenderFns } from "./MoralPersonData.vue?vue&type=template&id=a17c7ad8&scoped=true"
import script from "./MoralPersonData.vue?vue&type=script&lang=js"
export * from "./MoralPersonData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17c7ad8",
  null
  
)

export default component.exports